import script from "./ButtonFix.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonFix.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonFix.vue?vue&type=style&index=0&id=50bfa6f6&scoped=true&lang=css"
import "./ButtonFix.vue?vue&type=style&index=1&id=50bfa6f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50bfa6f6"]])

export default __exports__